"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareBreakpoints = exports.defaultBreakpointsMap = void 0;
exports.defaultBreakpointsMap = {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
    '3xl': 1920,
    '4xl': 2560,
};
const compareBreakpoints = (compare, current, breakpointsMap = exports.defaultBreakpointsMap) => {
    var _a, _b;
    const currentSize = (_a = breakpointsMap[current]) !== null && _a !== void 0 ? _a : 0;
    const compareSize = (_b = breakpointsMap[compare]) !== null && _b !== void 0 ? _b : 0;
    return currentSize >= compareSize ? 'fits' : 'smaller';
};
exports.compareBreakpoints = compareBreakpoints;
